import { render } from "./ProvidersAdmin.vue?vue&type=template&id=118605f6"
import script from "./ProvidersAdmin.vue?vue&type=script&lang=js"
export * from "./ProvidersAdmin.vue?vue&type=script&lang=js"

import "./ProvidersAdmin.vue?vue&type=style&index=0&id=118605f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__